import axios from 'axios';

export const acceptScreenHostAgreement = (token, { legalName, agreementAccepted = true, agreementVersion }) => {
    return axios.post(
        process.env.REACT_APP_API_URL + '/screenHost/acceptAgreement',
        {
            legalName,
            agreementAccepted,
            agreementVersion
        },
        { headers: { Authorization: token } }
    );
};
